module.exports = __webpack_public_path__ + "static/media/requestUser.61650fec.svg";